import { sharedCalculatorNav, sharedCalculatorTranslations } from './calculatorShared';

export const kk = {
  // Purchased Cars (Win Cars) view tabs
  winCarsView: {
    ourDealers: 'Біздің Дилерлер',
    allAuctionWins: 'Барлық Аукцион Жеңістері',
    ourDealersHint: 'Тек біздің тіркелген дилерлерге сатып алынған немесе тағайындалған көліктер.',
    allAuctionWinsHint: 'Аукцион ағынының барлық көліктері (анықтамалық).',
  },

  // Navigation
  nav: {
    dashboard: 'Басты',
    branches: 'Филиалдар',
    managers: 'Менеджерлер',
    dealers: 'Дилерлер',
    subdealers: 'Субдилерлер',
    winCars: 'Сатып Алынған Көліктер',
    accounts: 'Есептер',
    auctionFees: 'Аукцион Төлемдері',
    deliveryCost: 'Жеткізу Құны',
    statistics: 'Ставкалар',
    watchlist: 'Бақылау тізімі',
    tools: 'Құралдар',
    settings: 'Баптаулар',
    ...sharedCalculatorNav,
  },

  // Common
  common: {
    add: 'Қосу',
    edit: 'Өңдеу',
    delete: 'Жою',
    save: 'Сақтау',
    cancel: 'Болдырмау',
    create: 'Жасау',
    update: 'Жаңарту',
    back: 'Артқа',
    refresh: 'Жаңарту',
    search: 'Іздеу',
    actions: 'Әрекеттер',
    status: 'Мәртебе',
    contact: 'Байланыс',
    email: 'Эл. пошта',
    phone: 'Телефон',
    name: 'Аты',
    username: 'Пайдаланушы аты',
    password: 'Құпия сөз',
    confirmPassword: 'Құпия сөзді растау',
    loading: 'Жүктелуде...',
    noDataFound: 'Деректер табылмады',
    total: 'Барлығы',
    active: 'Белсенді',
    inactive: 'Белсенді емес',
    all: 'Барлығы',
    filters: 'Сүзгілер',
  },

  watchlist: { notFound: 'табылмады', remove: 'Тізімнен жою' },

  // Branches
  branches: {
    title: 'Филиалдарды басқару',
    addBranch: 'Филиал қосу',
    editBranch: 'Филиалды өңдеу',
    createBranch: 'Жаңа филиал жасау',
    branchName: 'Филиал атауы',
    branchCode: 'Филиал коды',
    location: 'Орналасқан жері',
    country: 'Ел',
    city: 'Қала',
    address: 'Мекенжай',
    totalBranches: 'Барлық филиалдар',
    activeBranches: 'Белсенді филиалдар',
    totalManagers: 'Барлық менеджерлер',
    totalDealers: 'Барлық дилерлер',
    totalSubdealers: 'Барлық субдилерлер',
    created: 'Жасалды',
    backToBranches: 'Филиалдарға оралу',
    noBranchesFound: 'Филиалдар табылмады',
    deleteBranchConfirm: 'Филиалды жойғыңыз келе ме',
  },

  // Managers
  managers: {
    title: 'Менеджерлерді басқару',
    addManager: 'Менеджер қосу',
    editManager: 'Менеджерді өңдеу',
    createManager: 'Жаңа менеджер жасау',
    firstName: 'Аты',
    lastName: 'Тегі',
    assignToBranch: 'Филиалға тағайындау',
    totalManagers: 'Барлық менеджерлер',
    georgiaManagers: 'Грузия филиалы',
    dubaiManagers: 'Дубай филиалы',
    armeniaManagers: 'Армения филиалы',
    activeBids: 'Белсенді ставкалар',
    monthlyRevenue: 'Айлық табыс',
    wonAuctions: 'Жеңілген аукциондар',
    backToManagers: 'Менеджерлерге оралу',
    noManagersFound: 'Менеджерлер табылмады',
    deleteManagerConfirm: 'Менеджерді жойғыңыз келе ме',
  },

  // Dealers
  dealers: {
    title: 'Дилерлерді басқару',
    addDealer: 'Дилер қосу',
    editDealer: 'Дилерді өңдеу',
    createDealer: 'Жаңа дилер жасау',
    totalDealers: 'Барлық дилерлер',
    georgiaDealers: 'Грузия дилерлері',
    dubaiDealers: 'Дубай дилерлері',
    armeniaDealers: 'Армения дилерлері',
    assignToManager: 'Менеджерге тағайындау',
    totalSubdealers: 'Барлық субдилерлер',
    totalSpent: 'Барлығы жұмсалды',
    successRate: 'Сәттілік пайызы',
    myBids: 'Менің ставкаларым және көліктерім',
    subdealersBids: 'Субдилерлердің ставкалары және көліктері',
    allBids: 'Барлық ставкалар және көліктер',
    myActiveBids: 'Менің белсенді ставкаларым',
    subdealersActiveBids: 'Субдилерлердің белсенді ставкалары',
    totalCarsWon: 'Барлығы жеңілген көліктер',
    backToDealers: 'Дилерлерге оралу',
    noDealersFound: 'Дилерлер табылмады',
    deleteDealerConfirm: 'Дилерді жойғыңыз келе ме',
    deleteDealer: 'Delete Dealer',
    loadingList: 'Loading dealers...',
    filtersActiveSuffix: 'filter(s) active',
    quickSearchPlaceholder: 'Search by Name, Username, Email, or Phone...',
    ctrlFHint: 'Ctrl+F / ⌘F',
    advancedFilters: 'Advanced Filters',
    branchFilterPh: 'Branch',
    managerFilterPh: 'Manager',
    allBranches: 'All Branches',
    allManagers: 'All Managers',
    clearFilters: 'Clear Filters',
    pageTotalShowing: 'Showing',
    pageTotalOf: 'of',
    pageTotalLabel: 'total',
    auctionAccountsTitle: 'Auction Accounts',
    auctionAccountsRequired:
      'Please select at least one primary auction account (Copart, IAAI, Manheim, or ACV).',
    passwordLeaveBlank: 'Password (leave empty to keep current)',
    passwordLabel: 'Password',
    phoneLabel: 'Phone',
    selectBranch: 'Select branch',
    selectManager: 'Select manager',
    toggleOn: 'On',
    toggleOff: 'Off',
    phFirst: 'e.g., Nikoloz',
    phLast: 'e.g., Baratashvili',
    phUsername: 'e.g., dealer.ge1',
    phEmail: 'dealer@bidmanager.com',
    phPhone: '+995 555 777 777',
    accountAmPlaceholder: '🇬🇪 GE Account',
    accountUsOptional: '🇺🇸 US Account (Optional)',
    noneOption: 'None',
    unknownBranch: 'Unknown Branch',
    bidLimitLabel: 'Bid Limit',
    activeBidsAmountLabel: 'Active Bids Amount',
    activeBidsSumLimitLabel: 'Active Bids Sum Limit',
    purchasedCarsLimitLabel: 'Purchased Cars Limit',
    lotsEventSettingLabel: 'Lots Event Setting',
    purchasedLotsSettingLabel: 'Purchased Lots Setting',
    showCalculatorWidget: 'Show Calculator Widget',
    showHelperTool: 'Show Helper Tool',
    showDiscountRow: 'Show Discount Row',
    fixedDiscountAmount: 'Fixed Discount Amount ($)',
    fixedDiscountHelp: 'Fixed discount amount in USD',
    iaaiCanadaTitle: 'IAAI (Canada)',
    calculatorSettingsSection: 'Calculator Settings',
    auctionLimitsSection: 'Auction & limits',
    visibilityHide: 'Hide',
    visibilityShow: 'Show',
    visibilityPartlyShow: 'Partly Show',
    visibilityWinningLots: 'Winning Lots',
    colDealer: 'Dealer',
    colBranch: 'Branch',
    colManager: 'Manager',
    colContact: 'Contact',
    colSubdealers: 'Subdealers',
    colActiveBids: 'Active Bids',
    colTotalSpent: 'Total Spent',
    colCreatedBy: 'Created By',
    colActions: 'Actions',
    tooltips: {
      bidLimit: 'Бір лотқа максималды ставка лимиті',
      activeBidsLimit: 'Пайдаланушы қанша ставка қойған. Жаңа пайдаланушылар үшін 0-ге орнатыңыз',
      activeBidsSumLimit: 'Пайдаланушы барлық лоттарға қоя алатын максималды жалпы USD сомасы',
      purchasedCarsLimit: 'Пайдаланушы сатып ала алатын максималды көлік саны',
      packageSlug: 'Пайдаланушы пакетінің түрі',
      lotsEventSetting: '"Менің ставкаларым" және "/dashboard" беттеріне қол жеткізуді басқарады',
      purchasedLotsSetting: 'Төлем қарызын және төлемдер тарихы беттерін көруге қол жеткізуді басқарады',
    },
  },

  // Subdealers
  subdealers: {
    title: 'Субдилерлерді басқару',
    addSubdealer: 'Субдилер қосу',
    editSubdealer: 'Субдилерді өңдеу',
    createSubdealer: 'Жаңа субдилер жасау',
    assignToDealer: 'Дилерге тағайындау',
    dealer: 'Дилер',
    branch: 'Филиал',
    manager: 'Менеджер',
    totalSpent: 'Барлығы жұмсалды',
    wonAuctions: 'Жеңілген аукциондар',
    activeBids: 'Белсенді ставкалар',
    backToSubdealers: 'Субдилерлерге оралу',
    noSubdealersFound: 'Субдилерлер табылмады',
    deleteSubdealerConfirm: 'Субдилерді жойғыңыз келе ме',
    tooltips: {
      bidLimit: 'Бір лотқа максималды ставка лимиті',
      activeBidsLimit: 'Пайдаланушы қанша ставка қойған. Жаңа пайдаланушылар үшін 0-ге орнатыңыз',
      activeBidsSumLimit: 'Пайдаланушы барлық лоттарға қоя алатын максималды жалпы USD сомасы',
      purchasedCarsLimit: 'Пайдаланушы сатып ала алатын максималды көлік саны',
      packageSlug: 'Пайдаланушы пакетінің түрі',
      lotsEventSetting: '"Менің ставкаларым" және "/dashboard" беттеріне қол жеткізуді басқарады',
      purchasedLotsSetting: 'Төлем қарызын және төлемдер тарихы беттерін көруге қол жеткізуді басқарады',
    },
  },

  // Bids & Cars
  bids: {
    lotNumber: 'Лот нөмірі',
    vin: 'VIN',
    vehicle: 'Көлік',
    bidAmount: 'Ставка сомасы',
    status: 'Мәртебе',
    bidder: 'Ставка қойған',
    subdealer: 'Субдилер',
    won: 'ЖЕҢІЛДІ',
    active: 'БЕЛСЕНДІ',
    lost: 'ЖЕҢІЛМЕДІ',
    totalBids: 'Барлық ставкалар',
    bidsAndCars: 'Ставкалар және көліктер',
    noBidsFound: 'Ставкалар табылмады',
  },

  layout: {
    footerBrand: 'Bidmanager жүйесі',
  },

  // Auth
  auth: {
    login: 'Кіру',
    logout: 'Шығу',
    welcomeBack: 'Қайта оралуыңызбен',
    signIn: 'Кіру',
    profile: 'Профиль',
    loginSubtitle: 'Көлік аукциондарын басқару жүйесі',
    usernamePlaceholder: 'Пайдаланушы аты',
    passwordPlaceholder: 'Құпия сөз',
    signingIn: 'Кіруде...',
    loginFailed: 'Кіру сәтсіз аяқталды. Деректерді тексеріңіз.',
    connectionError: 'Байланыс қатесі. Интернетті тексеріп қайталап көріңіз.',
    forgotPasswordQuestion: 'Құпия сөзді ұмыттыңыз ба?',
    forgotPasswordTitle: 'Құпия сөзді қалпына келтіру',
    forgotPasswordHint:
      'Құпия сөзді қалпына келтіру хатын алу үшін электрондық поштаны немесе пайдаланушы атын енгізіңіз.',
    resetByEmail: 'Пошта арқылы',
    resetByUsername: 'Пайдаланушы аты бойынша',
    emailPlaceholder: 'Электрондық поштаны енгізіңіз',
    forgotUsernamePlaceholder: 'Пайдаланушы атын енгізіңіз',
    sending: 'Жіберілуде...',
    sendResetEmail: 'Қалпына келтіру хатын жіберу',
    checkEmailTitle: 'Поштаңызды тексеріңіз',
    checkEmailBody:
      'Мұндай аккаунт бар болса, құпия сөзді қалпына келтіру хаты жіберілді. Пошта жәшігін тексеріңіз.',
    backToLogin: 'Кіру бетіне оралу',
    provideEmailOrUsername: 'Пошта немесе пайдаланушы атын көрсетіңіз',
    enterEmailAddress: 'Электрондық пошта мекенжайын енгізіңіз',
    enterUsernameRequired: 'Пайдаланушы атын енгізіңіз',
    requestFailedLater: 'Сұрау орындалмады. Кейінірек қайталап көріңіз.',
  },

  // Stats
  stats: {
    statistics: 'Статистика',
    dashboard: 'Басқару панелі',
  },

  // Dashboard
  dashboard: {
    systemAdminDashboard: 'Жүйе әкімшісінің панелі',
    branchManagerDashboard: 'Филиал менеджерінің панелі',
    dealerDashboard: 'Дилер панелі',
    yourAuctionDashboard: 'Сіздің аукцион панеліңіз',
    welcomeToDashboard: 'Bidmanager панеліне қош келдіңіз',
    welcomeBack: 'Қош келдіңіз',
    systemOverview: 'жүйенің',
    branchOverview: 'филиалдың',
    activityOverview: 'белсенділіктің',
    overview: 'шолу',
    hereIsYour: 'Міне сіздің',
    downloadApp: 'Қолданбаны жүктеу',
    downloadAppDesc: 'Аукциондарды басқару үшін мобильді қолданбаны алыңыз',
    downloadNow: 'Қазір жүктеу',
    yourManager: 'Сіздің менеджеріңіз',
    yourManagerDesc: 'Көмек алу үшін менеджеріңізбен байланысыңыз',
    whatsapp: 'WhatsApp',
    viber: 'Viber',
    tarifPlan: 'Тариф жоспары',
    basic: 'Базалық',
    planLimits: '5 көлік • $10,000 шек',
    upgradePlan: 'Жоспарды жаңарту',
    quickOverview: 'Жылдам шолу',
    priceList: 'Баға тізімі',
    oneActive: '1 Белсенді',
    twoOnline: '2 Онлайн',
    twoActive: '2 Белсенді',
    name: 'Аты',
    user: 'Пайдаланушы',
    account: 'Есептік жазба',
    auction: 'Аукцион',
    activity: 'Белсенділік',
    action: 'Әрекет',
    managePriceLists: 'Баға тізімдерін басқару',
    manageSubdealers: 'Субдилерлерді басқару',
    manageAccounts: 'Есептік жазбаларды басқару',
    online: 'Онлайн',
    systemMetrics: 'Жүйе көрсеткіштері',
    branchPerformance: 'Филиал өнімділігі',
    yourActivity: 'Сіздің белсенділігіңіз',
    totalBranches: 'Барлық филиалдар',
    activeBranchesWorldwide: 'Бүкіл әлемдегі белсенді филиалдар',
    branchManagers: 'Филиал менеджерлері',
    acrossAllBranches: 'Барлық филиалдарда',
    totalRevenue: 'Жалпы кіріс',
    totalPlatformRevenue: 'Платформаның жалпы кірісі',
    mySubdealers: 'Менің субдилерлерім',
    activeInYourBranch: 'Сіздің филиалыңызда белсенді',
    currentlyInProgress: 'Қазір орындалуда',
    byYourBranch: 'Сіздің филиалыңыз арқылы',
    currentlyBidding: 'Қазір ставка жасауда',
    thisMonth: 'Осы айда',
    totalBidsPlaced: 'Жалпы жасалған ставкалар',
    totalWonAuctions: 'Жалпы жеңілген аукциондар',
  },

  // Form validation
  validation: {
    required: 'Бұл өріс міндетті',
    invalidEmail: 'Қате эл. пошта мекенжайы',
    passwordMismatch: 'Құпия сөздер сәйкес келмейді',
    minLength: 'Ең аз ұзындығы',
    maxLength: 'Ең көп ұзындығы',
  },

  // Notifications
  notifications: {
    createSuccess: 'Сәтті жасалды',
    updateSuccess: 'Сәтті жаңартылды',
    deleteSuccess: 'Сәтті жойылды',
    error: 'Қате орын алды',
  },

  ...sharedCalculatorTranslations,

  // Delivery Cost
  deliveryCost: {
    title: 'Жеткізу құнын басқару',
    addNew: 'Жаңа орынды қосу',
    editLocation: 'Орынды өңдеу',
    location: 'Орын',
    fee: 'Құн',
    notes: 'Ескертпелер',
    auction: 'Аукцион',
    country: 'Ел',
    armenia: 'Армения',
    georgia: 'Грузия',
    auctionCopart: 'Copart',
    auctionIaai: 'IAAI',
    auctionManheim: 'Manheim',
    statsCopart: 'Copart:',
    statsIaai: 'IAAI:',
    statsManheim: 'Manheim:',
    totalLocations: 'Барлық орындар',
    searchLocation: 'Орынды іздеу',
    searchPlaceholder: 'мысалы, Атланта, Хьюстон...',
    addNotes: 'Ескертпелер қосу...',
    notesPlaceholder: 'Осы орын туралы қосымша ескертпелер...',
    confirmDelete: 'Жоюды растау',
    confirmDeleteMessage: 'Осы жеткізу құнын жойғыңыз келетініне сенімдісіз бе? Бұл әрекетті болдырмауға болмайды.',
    createSuccess: 'Жеткізу құны сәтті жасалды',
    updateSuccess: 'Жеткізу құны сәтті жаңартылды',
    deleteSuccess: 'Жеткізу құны сәтті жойылды',
    loadError: 'Жеткізу құндарын жүктеу сәтсіз аяқталды',
    saveError: 'Жеткізу құнын сақтау сәтсіз аяқталды',
    deleteError: 'Жеткізу құнын жою сәтсіз аяқталды',
    validationError: 'Орын және құн міндетті',
  },
};

